import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  centered: {
    alignItems: "center",
    textAlign: "center",
    // margin: "auto",
  },
  title: {
    fontSize: rem(34),
    fontWeight: 700,
    fontFamily: "Inter",
    marginBottom: rem(20),
  },
  description: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#979797",
  },
  logo: {
    marginTop: rem(111),
    marginBottom: rem(40),
  },
  type: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#97979726",
    borderStyle: "solid",
    padding: 20,
  },
  selected: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#FFBA45",
    borderStyle: "solid",
    padding: 20,
  },
  myfont: {
    fontFamily: "Inter",
  },
  card: {
    width: "100%",
    marginTop: 50,
    overflow: "unset",
  },
  payBtn: {
    fontFamily: "Inter",
    marginTop: rem(50),
    marginBottom: rem(50),
  },
  m10: {
    marginTop: rem(10),
    marginBottom: rem(10),
  },
  font1: {
    fontSize: rem(20),
    fontWeight: 500,
    fontFamily: "Inter",
    cursor: "pointer",
  },
  font2: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#979797",
  },
  back: {
    position: "absolute",
    top: rem(50),
    left: rem(50),
    fontSize: rem(16),
    fontFamily: "Inter",
    fontWeight: 500,
  },
  plaidComponent: {
    // cursor: "pointer",
    border: "1px solid #F2F2F2",
    borderRadius: "10px",
    width: "65%",
    "@media (max-width: 900px)": {
      width: "80%",
    },
    "@media (max-width: 768px)": {
      width: "90%",
    },
  },
  connectBankImage: {
    width: "30%",
    "@media (max-width: 500px)": {
      width: "100%",
    },
  },
  insideFlex: {
    width: "60%",
    "@media (max-width: 500px)": {
      width: "95%",
      padding: "10px",
    },
  },
  marginTop: {
    "@media (max-width:992px)": {
      marginTop: "15px",
    },
  },

  paymentPageBox: {
    width: "100%",
    height: "fit-content",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  paymentPageBoxRight: {
    width: "50%",
    padding: "30px 40px",
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& form": {
      display: "flex",
      flexDirection: "column",
      gap: 14,
      width: "100%",
      "& > h4": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
        fontSize: 24,
        fontWeight: 600,
        fontFamily: "Inter",
        color: "#101828",
        textAlign: "center",
        margin: 0,
        marginBottom: 32,
        "& svg": {
          color: "#000000",
        },
      },
    },
    "@media (max-width: 768px)": {
      width: "100%",
      padding: "24px 16px",
    },
  },
  paymentPageBoxLeft: {
    padding: "30px 40px",
    width: "50%",
    height: "inherit",
    backgroundColor: "#FCFCFC",
    "@media (max-width: 768px)": {
      width: "100%",
      padding: "24px 16px",
      height: "auto",
    },
  },
  paymentLeftContent: {
    paddingInline: 50,
    "& p": {
      margin: 0,
    },
    "& .hdng": {
      fontSize: 22,
      fontWeight: 700,
      fontFamily: "Inter",
      color: "#000",
      margin: 0,
    },
    "& .subHdng": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#84949E",
      marginBottom: 20,
    },
    "& .trialPkgNameText": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#262626",
      display: "flex",
      alignItems: "center",
    },
    "& .trialText": {
      color: "#FFBA45",
    },
    "@media (max-width: 768px)": {
      paddingInline: 0,
    },
  },
  paymentPageBoxLeftInner: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    width: "100%",
  },
  paymentPageBoxLogo: {
    width: 160,
    "@media (max-width: 768px)": {
      width: 120,
    },
  },
  pkgSelectBox: {
    marginTop: 10,
    padding: "19px 12px",
    cursor: "pointer",
    alignItems: "center",
    gap: 10,
    borderRadius: 5,
    border: "1px solid #EFEFEF",
    backgroundColor: "#FDFDFD",
    "& .pkgInfo": {
      flex: 1,
    },
    "& .radioBtn .mantine-Radio-radio": {
      borderColor: "#000000",
    },
    "& .radioBtn .mantine-Radio-radio:checked": {
      borderColor: "#FAB714",
      backgroundColor: "#FAB714",
    },
    "& .pkgDurationText": {
      fontSize: 16,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#1B252B",
    },
    "& .pkgPrice": {
      fontSize: 14,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "#8A9399",
      "& > .staffAndClientCount": {
        fontSize: 11,
        marginLeft: 6,
      },
    },
    "& .savePer": {
      fontSize: 12,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#191919",
    },
  },
  selectedPkgSelectBox: {
    border: "1px solid #FAB714",
  },
  staffAndClientAddSecHdng: {
    color: "#262626",
    fontWeight: 500,
    fontSize: 14,
    fontFamily: "Inter",
    marginTop: "19px !important",
  },
  staffAndClientCountBox: {
    border: "1px solid #EFEFEF",
    backgroundColor: "#FDFDFD",
    borderRadius: 5,
    padding: "10px 5px",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  staffAndClientAddSecSubHdng: {
    color: "#979797",
    fontWeight: 500,
    fontSize: 9,
    fontFamily: "Inter",
    marginBottom: "10px !important",
  },
  staffClientIncBtn: {
    backgroundColor: "#FFF",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
    "&:hover": {
      backgroundColor: "#FFF !important",
    },
  },
  staffAndClientSliderInput: {
    backgroundColor: "#FFF",
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    minWidth: "60px",
    maxWidth: "60px",
    color: "#171717",
    fontWeight: 500,
    fontSize: 13,
    padding: "8px 6px",
    outline: "none",
    fontFamily: "Inter",
  },
  staffAndClientLabel: {
    fontFamily: "Inter",
    color: "#171717",
    fontWeight: 500,
    fontSize: 16,
  },
  staffAndClientSlider: {
    flex: 1,
  },
  staffAndClientSliderTrack: {
    height: 6,
    "&::before": {
      backgroundColor: "#3F3F46",
    },
  },
  staffAndClientSliderBar: {
    backgroundColor: "#FFAF4A",
    height: 6,
  },
  staffAndClientSliderThumb: {
    backgroundColor: "#FFAF4A",
    border: "none",
    boxShadow: "0 0 10px rgba(255, 175, 74, 0.5)",
  },
  paymentInputFieldStyle: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#404040",
      marginBottom: 6,
    },
    "& .mantine-Input-wrapper": {
      padding: "10px 14px",
      height: 44,
      borderRadius: 8,
      border: "1px solid #D0D5DD",
      background: "#FFF",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      "& input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#171717",

        "&:-webkit-autofill": {
          boxShadow: "0 0 0px 1000px transparent inset !important",
          WebkitTextFillColor: "#171717",
          transition: "background-color 5000s ease-in-out 0s",
        },

        "&::placeholder": {
          color: "#737373",
        },
      },
    },
  },
  paymentBtn: {
    marginTop: 24,
    width: "100%",
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  couponCodeInput: {
    flex: 1,
  },
  couponCodeSubmitBtn: {
    width: "fit-content",
    marginTop: 0,
  },
  paymentPriceRow: {
    width: "100%",
    justifyContent: "space-between",
    marginBlock: 7,
    "& p": {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 500,
      color: "#262626",
    },
    "& .trialText": {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 500,
      color: "#606060",
    },
  },
  totalPriceRow: {
    width: "100%",
    gap: 50,
    justifyContent: "flex-end",
    marginTop: 18,
    "& p": {
      fontFamily: "Inter",
      fontSize: 24,
      fontWeight: 700,
      color: "#262626",
    },
    "& p:last-child": {
      fontWeight: 500,
    },
    "@media (max-width: 768px)": {
      gap: 16,
      justifyContent: "space-between",
      "& p": {
        fontSize: 20,
      },
    },
  },
  paymentPageBoxBackBtn: {
    display: "flex",
    alignItems: "center",
    fontFamily: "Inter",
    gap: 8,
    fontSize: 16,
    fontWeight: 500,
    color: "#171717",
    marginBottom: 10,
  },
  outcomeNumberInput: {
    width: "100%",
    "& .mantine-Input-input": {
      textAlign: "center",
      background: "transparent",
      color: "#262626",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: 400,
    },
    "& .mantine-Input-input:focus": {
      border: "none !important",
    },
    "& .mantine-Input-wrapper": {
      padding: "9px 13px",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      borderRadius: "8px",
      background: "#FAFAFA",
    },
    "& .mantine-Input-rightSection": {
      marginRight: "13px",
    },
    "& .mantine-Input-icon": {
      marginLeft: "13px",
      pointerEvents: "unset",
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  inc_dec_Btn: {
    borderRadius: "50%",
    height: "26px",
    width: "26px",
    backgroundColor: "#FFF",
    filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
    padding: "0px",
    "&:hover": {
      backgroundColor: "#FFF",
    },
  },
  validationErrorMsg: {
    fontSize: 12,
    fontWeight: 400,
    fontFamily: "Inter",
    color: "red",
    marginTop: "2px !important",
  },
  agreeTermsCondText: {
    margin: 0,
    fontSize: 13,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#84949E",
    "& a": {
      color: "#FFAF4A",
      textDecoration: "none"
    },
  },
}));
